(function () {
  'use strict';

  // Skip if user prefers reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Section-level selectors — every major wrapper this theme renders
  var SECTION_SELECTORS = [
    '.section',
    '.hero',
    '.marquee',
    '.media-with-content',
    '.slideshow',
    '.carousel',
    '.featured-product',
    '.collection-list',
    '.product-list',
    '.featured-blog-posts',
    '.footer-content',
  ].join(', ');

  // Child card selectors — items inside sections that get staggered
  var CHILD_SELECTORS = [
    '.resource-list__item',
    '.product-grid__item',
    '.collection-card',
    '.product-card',
    '.blog-post-card',
    '.carousel__item',
    '.media-with-content__media',
    '.media-with-content__content',
  ].join(', ');

  // Don't animate the hero above the fold
  var SKIP_SELECTORS = ['.hero', '.layered-slideshow'];

  function isAboveFold(el) {
    return el.getBoundingClientRect().top < window.innerHeight * 0.1;
  }

  function shouldSkip(el) {
    return SKIP_SELECTORS.some(function (sel) {
      return el.matches(sel);
    });
  }

  function init() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: just show everything
      document.querySelectorAll('.kem-anim, .kem-anim-child').forEach(function (el) {
        el.classList.add('kem-visible');
      });
      return;
    }

    // Observer for section wrappers
    var sectionObs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('kem-visible');
            sectionObs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    // Observer for child cards (staggered)
    var childObs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('kem-visible');
            childObs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.06, rootMargin: '0px 0px -20px 0px' }
    );

    // Tag and observe sections
    document.querySelectorAll(SECTION_SELECTORS).forEach(function (el) {
      if (shouldSkip(el) || isAboveFold(el)) return;
      el.classList.add('kem-anim');
      sectionObs.observe(el);
    });

    // Tag and observe child cards
    document.querySelectorAll(CHILD_SELECTORS).forEach(function (el) {
      // Skip if parent section is above fold
      var parentSection = el.closest('.section, .collection-list, .product-list');
      if (parentSection && isAboveFold(parentSection)) return;
      el.classList.add('kem-anim-child');
      childObs.observe(el);
    });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on Shopify section re-renders (theme editor)
  document.addEventListener('shopify:section:load', function () {
    // Reset any newly loaded sections
    document.querySelectorAll('.kem-anim:not(.kem-visible), .kem-anim-child:not(.kem-visible)').forEach(function (el) {
      el.classList.remove('kem-anim', 'kem-anim-child');
    });
    init();
  });

})();
